<template>
  <div class="background">
    <MainContent />
  </div>
</template>

<script>
// Modificar o componente que será exibido
import MainContent from "../components/Maintenance.vue";

export default {
  name: "Maintenance",

  components: {
    MainContent,
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/variables.scss";
div.background {
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../assets/layout/default_bg.svg");
  background-size: cover;
  background-repeat: no-repeat;
  margin: 0;
  overflow: hidden;
  height: 100vh;
}

@media (max-width: $mobile-bp) {
  div.background {
    background-color: $branco-neutro;
    background-image: none;
  }
}
</style>
